<template>
  <div :class="className" :style="{height: height, width: width}"/>
</template>

<script>
import { chartResize, echarts, echartCommon } from "../config"
import defaultSettings from "./config"
export default {
    name: "BarChart",
    mixins: [chartResize, echartCommon],
    beforeCreate () {
        this.DEFAULT_SETTINGS = defaultSettings()
    },
    watch: {
        chartData: {
            handler () {
                if (!this.chart) {
                    this.$nextTick(() => {
                        this.chart = echarts.init(this.$el, "macarons")
                        this.initChart(this.DEFAULT_SETTINGS)
                    })
                } else {
                    this.initChart(this.DEFAULT_SETTINGS)
                }
            },
            immediate: true
        }
    }
}
</script>
